import { render, staticRenderFns } from "./DialogSummary.vue?vue&type=template&id=49b984a1&scoped=true&"
import script from "./DialogSummary.vue?vue&type=script&lang=ts&"
export * from "./DialogSummary.vue?vue&type=script&lang=ts&"
import style0 from "./DialogSummary.vue?vue&type=style&index=0&id=49b984a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b984a1",
  null
  
)

export default component.exports